import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { IEpGridModel, EpEventService, IEpGridSelectionOptions, EpGridEvent, IEpComponentEventArg } from '@epicor/kinetic';
import { BistrackConfig, CustomEvents } from 'ep-bt-controls';
import { FieldAgentClient } from 'ep-bt-field-agent-proxy';
import { Router } from '@angular/router';
import { EpbtFaProductService } from '../../services/epbt-fa-product.service';
import { EpbtFaProductBinlocationService } from '../../services/epbt-fa-product-binlocation.service';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';

declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-bin-location-selected-product-grid',
  templateUrl: './epbt-fa-bin-location-selected-product-grid.component.html',
  styleUrls: ['./epbt-fa-bin-location-selected-product-grid.component.scss']
})
export class EpbtFaBinLocationSelectedProductGridComponent implements OnInit {

  products: any;
  public gridModel: IEpGridModel;
  bistrackSettings: any;
  currency: string;
  webTrackUser: any;
  branchId: number;

  @Input() deleteFlag = false;

  @ViewChild('currencyTemplate', {static: true}) currencyTemplate: TemplateRef<any>;
  @ViewChild('decimalTemplate', {static: true}) decimalTemplate: TemplateRef<any>;
  @ViewChild('removeTemplate', {static: true}) removeTemplate: TemplateRef<any>;

  constructor(private client: FieldAgentClient, private router: Router, private config: BistrackConfig,
    public epEvent: EpEventService, private productService: EpbtFaProductService,
    private binLocationService: EpbtFaProductBinlocationService,
    private faService: EpbtFieldAgentService) {
  }

  ngOnInit() {
    this.faService.getBisTrackSetting((bistrackSettings: any) => {
      this.bistrackSettings = bistrackSettings;
      this.currency = this.bistrackSettings.baseCurrency.symbol;
      this.gridModel = this.getGridModel();
      this.binLocationService.prepareData(false);
      this.gridModel.data = this.binLocationService.selectedProductsForBinding;
    });
  }


  getGridModel(): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'productId',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      scrollable: 'scrollable',
      rowHeight: 20,
      height: this.getHeight(),
      sortable: true,
      selectionOptions: selectionOptions,
      columns: [
        { field: 'productCode', title: 'CODE', width: 30, hidden: false },
        { field: 'description', title: 'DESCRIPTION', width: 30, hidden: false },
        { field: 'standardSellPrice', title: 'SELL PRICE', width: 30, hidden: !this.deleteFlag, cellTemplate: this.currencyTemplate },
        { field: 'stockAvailable', title: 'AVAIL', width: 30, hidden: !this.deleteFlag, cellTemplate: this.decimalTemplate },
        { field: 'binLocations', title: this.deleteFlag ? 'BIN(S)' : 'BIN(S) BEFORE', width: 30, hidden: false },
        { field: 'binLocationsAfter', title: 'BIN(S) AFTER', width: 30, hidden: this.deleteFlag },
        { title: 'DELETE', width: 30, hidden: !this.deleteFlag, class: 'ep-color-red', cellTemplate: this.removeTemplate }
      ],
      epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
        if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type == 'click') {
          this.epEvent.broadcast(CustomEvents.BinLocationSummaryClick, 1);
        }
      },
      // fnEvent: (event: EpGridEvent, args: any) => {
      //   if (event === EpGridEvent.cellClick) {
      //     this.epEvent.broadcast(CustomEvents.BinLocationSummaryClick, 1);
      //   }
      // },
    };
    $(window).resize(() => {
      this.updateGrid();
    });
    return model;
  }

  updateGrid() {
    const calHeight = this.getHeight();
    this.gridModel.height = calHeight;
  }

  // grid height calculation start
  getHeight(): number {

    const heightVal: number = !this.deleteFlag ? 550 : 280;
    const height = $(window).outerHeight() - heightVal; // 583
    const width = parseInt($('body').width());

    if (width > 250 && width < 1023) {
      // mobile and ipad
      return 400;
    }
    return height > 100 ? height : 100;

  }
  // getHeight(): number {
  //   var height = parseInt($('body').height());

  //   if (height > 900) {
  //     //return 300;
  //     return 600;
  //   }
  //   else return 400;//return 500;
  // }
  // grid height calculation end

  updateGridData(flag: boolean) {
    this.binLocationService.prepareData(flag);
    this.gridModel.data = this.binLocationService.selectedProductsForBinding.slice();
  }

  onCardClick(model) {
    // this.productService.selectedProductItem = model;
    // this.router.navigate(['/home/product/details', model.productId]);
    this.epEvent.broadcast(CustomEvents.BinLocationSummaryClick, 1);
  }

  onRemove(dataItem: any) {
    const index = this.binLocationService.selectedProducts.findIndex(c => c.productId == dataItem);
    if (index >= 0) {
      this.binLocationService.selectedProducts.splice(index, 1);
      this.gridModel.data = this.binLocationService.selectedProducts.slice();
    }
  }
}
